<template>
  <div class="div-center">
    <v-progress-circular :size="70" :width="7" color="accent" indeterminate></v-progress-circular>
  </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style lang="scss" scoped>
.div-center {
  text-align: center;
  width: 100%;
}
</style>
